import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { map } from 'rxjs/operators';
import {SERVER_API_URL} from '../../../app.constants';
import {IProcessInstanceParam} from '../model/processInstanceParam.model';
import {IProcessInstance} from "../model/processInstance.model";
import {IRunModel} from "../model/runModel.model";


type EntityResponseType_msg = HttpResponse<IRunModel>;
type EntityArrayResponseType_msg = HttpResponse<IRunModel[]>;

type EntityResponseType = HttpResponse<IProcessInstanceParam>;
type EntityArrayResponseType = HttpResponse<IProcessInstanceParam[]>;

type EntityResponseType2 = HttpResponse<IProcessInstance>;
type EntityArrayResponseType2 = HttpResponse<IProcessInstance[]>;

@Injectable({ providedIn: 'root' })
export class BpmsService {
  public resourceUrl = SERVER_API_URL + 'api/start_ejra_process3';
  public resourceUrl2 = SERVER_API_URL + 'api/getIns';
  public resourceUrlDelIns = SERVER_API_URL + 'api/del-ins';
  public resourceUrl3 = SERVER_API_URL + 'api/start-ejrat-to-sabtename-res';

  public resourceUrl_boostan = SERVER_API_URL + 'api/start-boostan';
  public resourceUrl_sale_proc = SERVER_API_URL + 'api/start-sale-proc';
  // public resourceUrlDelIns = 'http://localhost:8090/delete-all-ins';
  // public resourceSearchUrl = SERVER_API_URL + 'api/_search/blm-classes';
  // public resourceUrlIndex = SERVER_API_URL + 'api/blm-classes-index';
  // public resourceUrlIndexDel = SERVER_API_URL + 'api/blm-classes-index-del';

  constructor(protected http: HttpClient) {}

  deletInstance(): Observable<EntityResponseType> {
    return this.http
      .get<any>(this.resourceUrlDelIns, { observe: 'response' })
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  startEjra(): Observable<HttpResponse<IProcessInstance>> {
    return this.http.get<IProcessInstance>(this.resourceUrl, { params: null, observe: 'response' });
  }

  startEjraToSabtenam(): Observable<HttpResponse<IProcessInstance>> {
    return this.http.get<IProcessInstance>(this.resourceUrl3, { params: null, observe: 'response' });
  }



  startSaleProc(id: any,address: any,customer: any): Observable<EntityResponseType_msg> {
    return this.http
      .get<IRunModel>(`${this.resourceUrl_sale_proc}/${id}/${address}/${customer}`, { observe: 'response' })
      .pipe(map((res: EntityResponseType_msg) => this.convertDateFromServer_msg(res)));
  }

  startBoostan(id: any,address: any,customer: any): Observable<EntityResponseType_msg> {
    return this.http
      .get<IRunModel>(`${this.resourceUrl_boostan}/${id}/${address}/${customer}`, { observe: 'response' })
      .pipe(map((res: EntityResponseType_msg) => this.convertDateFromServer_msg(res)));
  }

  startEjra2(nameSolt: any,codeSolt: any,codeClass: any): Observable<EntityResponseType_msg> {
    return this.http
      .get<IRunModel>(`${this.resourceUrl3}/${nameSolt}/${codeSolt}/${codeClass}`, { observe: 'response' })
      .pipe(map((res: EntityResponseType_msg) => this.convertDateFromServer_msg(res)));
  }


  // startEjra2(nameSolt,codeSolt,codeClass): Observable<HttpResponse<IRunModel>> {
  //   return this.http.get<IRunModel>(`${this.resourceUrl3}/${nameSolt}/${codeSolt}/${codeClass}`, { params: null, observe: 'response' });
  // }
  // startEjra(): Observable<HttpResponse<IProcessInstanceParam>> {
  //   return this.http.get<any>(this.resourceUrl, { params: null, observe: 'response' });
  // }
  listInstance(): Observable<HttpResponse<IProcessInstanceParam>> {
    return this.http.get<IProcessInstanceParam>(this.resourceUrl2, { params: null, observe: 'response' });
  }

  // queryIndexDel(): Observable<HttpResponse<any>> {
  //   return this.http.get<any>(this.resourceUrlIndexDel, { params: null, observe: 'response' });
  // }
  //
  // create(blmClass: IBlmClass): Observable<EntityResponseType> {
  //   const copy = this.convertDateFromClient(blmClass);
  //   return this.http
  //     .post<IBlmClass>(this.resourceUrl, copy, { observe: 'response' })
  //     .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  // }
  //
  // update(blmClass: IBlmClass): Observable<EntityResponseType> {
  //   const copy = this.convertDateFromClient(blmClass);
  //   return this.http
  //     .put<IBlmClass>(this.resourceUrl, copy, { observe: 'response' })
  //     .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  // }

  find(): Observable<EntityResponseType> {
    return this.http
      .get<IProcessInstanceParam>(`${this.resourceUrl2}`, { observe: 'response' })
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }


  approve(id: number): Observable<EntityResponseType> {
    return this.http
      .get<IProcessInstanceParam>(`${this.resourceUrl}/${id}`, { observe: 'response' })
      .pipe(map((res: EntityResponseType) => this.convertDateFromServer(res)));
  }

  //
  // query(req?: any): Observable<EntityArrayResponseType> {
  //   const options = createRequestOption(req);
  //   return this.http
  //     .get<IBlmClass[]>(this.resourceUrl, { params: options, observe: 'response' })
  //     .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  // }
  //
  // delete(id: number): Observable<HttpResponse<any>> {
  //   return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  // }
  // search(req?: any): Observable<EntityArrayResponseType> {
  //   const options = createRequestOption(req);
  //   return this.http
  //     .get<IBlmClass[]>(this.resourceSearchUrl, { params: options, observe: 'response' })
  //     .pipe(map((res: EntityArrayResponseType) => this.convertDateArrayFromServer(res)));
  // }

  protected convertDateFromClient(blmClass: IProcessInstanceParam): IProcessInstanceParam {
    const copy: IProcessInstanceParam = Object.assign({}, blmClass, {
      // datCREATEDatClas:
      //   blmClass.datCREATEDatClas != null && blmClass.datCREATEDatClas.isValid()
      //     ? blmClass.datCREATEDatClas.format(DATE_FORMAT)
      //     : null,
      // datUPDATEDatClas:
      //   blmClass.datUPDATEDatClas != null && blmClass.datUPDATEDatClas.isValid()
      //     ? blmClass.datUPDATEDatClas.format(DATE_FORMAT)
      //     : null,
      // numSTARTExePRCClas:
      //   blmClass.numSTARTExePRCClas != null && blmClass.numSTARTExePRCClas.isValid()
      //     ? blmClass.numSTARTExePRCClas.format(DATE_FORMAT)
      //     : null,
      // datDECLARExeClas:
      //   blmClass.datDECLARExeClas != null && blmClass.datDECLARExeClas.isValid()
      //     ? blmClass.datDECLARExeClas.format(DATE_FORMAT)
      //     : null,
      // datMOSAVABEClas:
      //   blmClass.datMOSAVABEClas != null && blmClass.datMOSAVABEClas.isValid()
      //     ? blmClass.datMOSAVABEClas.format(DATE_FORMAT)
      //     : null,
      // datAKMoSAVABEClas:
      //   blmClass.datAKMoSAVABEClas != null && blmClass.datAKMoSAVABEClas.isValid()
      //     ? blmClass.datAKMoSAVABEClas.format(DATE_FORMAT)
      //     : null
    });
    return copy;
  }

  protected convertDateFromServer(res: EntityResponseType): EntityResponseType {
    if (res.body) {
      // res.body.datCREATEDatClas = res.body.datCREATEDatClas != null ? moment(res.body.datCREATEDatClas) : null;
      // res.body.datUPDATEDatClas = res.body.datUPDATEDatClas != null ? moment(res.body.datUPDATEDatClas) : null;
      // res.body.numSTARTExePRCClas = res.body.numSTARTExePRCClas != null ? moment(res.body.numSTARTExePRCClas) : null;
      // res.body.datDECLARExeClas = res.body.datDECLARExeClas != null ? moment(res.body.datDECLARExeClas) : null;
      // res.body.datMOSAVABEClas = res.body.datMOSAVABEClas != null ? moment(res.body.datMOSAVABEClas) : null;
      // res.body.datAKMoSAVABEClas = res.body.datAKMoSAVABEClas != null ? moment(res.body.datAKMoSAVABEClas) : null;
    }
    return res;
  }

  protected convertDateFromServer_msg(res: EntityResponseType_msg): EntityResponseType_msg {
    if (res.body) {
     }
    return res;
  }

  protected convertDateArrayFromServer(res: EntityArrayResponseType): EntityArrayResponseType {
    if (res.body) {
      res.body.forEach((blmClass: IProcessInstanceParam) => {
        // blmClass.datCREATEDatClas = blmClass.datCREATEDatClas != null ? moment(blmClass.datCREATEDatClas) : null;
        // blmClass.datUPDATEDatClas = blmClass.datUPDATEDatClas != null ? moment(blmClass.datUPDATEDatClas) : null;
        // blmClass.numSTARTExePRCClas = blmClass.numSTARTExePRCClas != null ? moment(blmClass.numSTARTExePRCClas) : null;
        // blmClass.datDECLARExeClas = blmClass.datDECLARExeClas != null ? moment(blmClass.datDECLARExeClas) : null;
        // blmClass.datMOSAVABEClas = blmClass.datMOSAVABEClas != null ? moment(blmClass.datMOSAVABEClas) : null;
        // blmClass.datAKMoSAVABEClas = blmClass.datAKMoSAVABEClas != null ? moment(blmClass.datAKMoSAVABEClas) : null;
      });
    }
    return res;
  }

}
